<template>
  <tr @dblclick="$refs['actions'].callFirstStarredAction();"
    class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Id') }}</span>
      <FieldReadonly :value="office.id" />
    </td>
    <td class="d-block d-lg-table-cell" v-if="!company">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Company') }}</span>
      <FieldReadonly :value="office.company" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Name') }}</span>
      <FieldReadonly :value="office.name" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Address') }}</span>
      <FieldReadonly :value="office.address" />
    </td>
    <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
      <ActionDropdown ref="actions" :actions="actions" />
    </td>
  </tr>
</template>

<script>
import api from "@/api.js";
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";

export default {
  components: {
    FieldReadonly,
    ActionDropdown,
  },
  props: {
    company: {
      type: Object,
    },
    office: Object,
  },
  data() {
    return {};
  },
  emits: [
    'edit',
    'deleted',
    'updating',
    'updated',
  ],
  methods: {
  },
  computed: {
    actions() {
      return [{
        label: this.i18n('Edit'),
        fn: () => {
          this.$emit('edit', this.office);
        },
        if: (this.office.acl?.update) === true,
        starred: true,
      },
      {
        label: this.i18n('Detail'),
        fn: () => {
          this.$emit('edit', this.office);
        },
        if: (this.office.acl?.update) !== true,
        starred: true,
      },
      {
        label: this.i18n('Delete'),
        fn: () => {
          this.$emit('updating', this.office);
          this.$root.requestConfirmation(this.i18n('Delete? This action cannot be undone.'), () => {
            let route = `offices/${this.office.id}`;
            if (this.company) {
              route = `companies/${this.company.id}/${route}`;
            }

            api.delete(route).then(() => {
              this.$emit('deleted', this.office);
              api.clearCache();
            }).then(() => {
              // Force reload
              this.$emit('updated', this.office);
            });
          });
        },
        if: (this.office.acl?.delete) === true,
        starred: false,
      },
      ];
    },
  },
};
</script>